import { AppraiserActionType } from '../AppraiserConstants';

export const getAppraiserActions = (
    appraiser: {
        id: number;
    },
    inactive = false
) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const actions: any[] = [];
    if (inactive) {
        actions.push({
            id: AppraiserActionType.Restore,
            text: 'Restore',
            appraiserId: appraiser.id,
            stylingMode: 'contained',
            disabled: false,
        });
    } else {
        actions.push({
            id: AppraiserActionType.Modify,
            text: 'Edit',
            appraiserId: appraiser.id,
            icon: 'edit',
            stylingMode: 'contained',
            disabled: false,
        });
        actions.push({
            id: AppraiserActionType.Delete,
            text: 'Delete',
            appraiserId: appraiser.id,
            type: 'danger',
            icon: 'remove',
            disabled: false,
        });
    }
    return actions;
};
